module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_4.50ad3b80.png";